import { type FC } from 'react';
import { Box, Typography } from '@mui/material';
import { pdfFileParser } from '../utils';

interface PdfListProps {
  pdfPaths: string[];
  onPdfClick: (pdfUrl: string, fileName: string) => void;
}

const PdfList: FC<PdfListProps> = ({ pdfPaths, onPdfClick }) => {
  return (
    <>
      {pdfPaths.map((pdfPath, index) => {
        const pdf = pdfFileParser(pdfPath);

        return (
          <Box key={index} sx={{ marginBottom: 1 }}>
            <Typography
              sx={{
                textDecoration: 'underline',
                color: '#008DDA',
                cursor: 'pointer',
                '&:hover': {
                  color: '#0056b3',
                },
              }}
              onClick={() => {
                onPdfClick(pdf.to, pdf.fileName || `PDF ${index + 1}`);
              }}
            >
              {pdf.fileName || `PDF ${index + 1}`}
            </Typography>
          </Box>
        );
      })}
    </>
  );
};

export default PdfList;
